import { render, staticRenderFns } from "./RAccordion.vue?vue&type=template&id=baf26998&scoped=true&"
import script from "./RAccordion.vue?vue&type=script&lang=js&"
export * from "./RAccordion.vue?vue&type=script&lang=js&"
import style0 from "./RAccordion.vue?vue&type=style&index=0&id=baf26998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf26998",
  null
  
)

export default component.exports